<template>
  <Row>
    <Col span="18">
      <DatePicker
        type="daterange"
        :options="options"
        placement="bottom-start"
        placeholder="请选择时间"
        v-model="seTime"
        class="public-inp"
      ></DatePicker>
      <Select v-model="status" placeholder="请选择状态" class="public-inp">
        <Option
          v-for="item in statusList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
      <!-- <Select v-model="target" placeholder="请选择发送对象"  class="public-inp">
            <Option 
            v-for="item in targetList" 
            :value="item.value" 
            :key="item.value">{{ item.label }}</Option>
        </Select> -->
      <Input
        v-model="searchName"
        placeholder="请输入消息关键字"
        class="public-inp"
      />
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'messageList.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'messageList.reset'">重置</Button>
    </Col>
    <Col span="6">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        @click="openFn()"
        v-access="'messageList.add'"
        >添加消息</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.id }}</span>
          {{ (page - 1) * pageSize + index + 1 }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'messageList.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="toDetail(row)"
            v-access="'messageList.details'"
            >查看</a
          >
          <a
            href="javascript:;"
            @click="openFn(row, index)"
            v-access="'messageList.edit'"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(index, row)"
            v-access="'messageList.delete'"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增消息' : '编辑消息'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="消息标题" prop="title">
          <Input v-model="formItem.title" placeholder="请输入标题"></Input>
        </FormItem>
        <FormItem label="消息类型" prop="type">
          <Select
            v-model="formItem.type"
            placeholder="请选择类型"
            @on-change="typeChange"
          >
            <Option value="0">文本</Option>
            <Option value="1">富文本</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="发送对象" prop="target">
          <Select v-model="formItem.target" placeholder="请选择发送对象">
            <Option
              v-for="item in targetList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem> -->
        <FormItem label="推送首页" prop="indexFlag">
          <Select v-model="formItem.indexFlag" placeholder="请选择是否推送首页">
            <Option value="1">推送首页</Option>
            <Option value="0">不推送首页</Option>
          </Select>
        </FormItem>
        <FormItem label="发送时间" prop="effectTime">
          <DatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发送时间"
            :value="formItem.effectTime"
            @on-change="timeChange"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <!-- <FormItem label="备注">
          <Input
            v-model="formItem.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入备注"
          ></Input>
        </FormItem> -->
        <FormItem label="文本消息" prop="content" v-show="formItem.type != 1">
          <Input
            v-model="formItem.content"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入消息内容"
          ></Input>
        </FormItem>
        <!-- 富文本编辑器 -->
        <FormItem label="图文消息" prop="content" v-show="formItem.type == 1">
          <div ref="editor"></div>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import E from "wangeditor";
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "标题",
    key: "title",
  },
  {
    title: "类型",
    key: "type",
    render: (h, params) => {
      // 0：文本 1：富文本
      let s = params.row.type;
      let t = s == "1" ? "富文本" : "文本";
      return h("span", t);
    },
  },
  //   {
  //     title: "发送用户",
  //     key: "target",
  //     render: (h, params) => {
  //       //  0:全部 1：门店 2：消费者
  //       let s = params.row.target;
  //       let t = s == "2" ? "消费者" : s == "1" ? "门店" : "全部";
  //       return h("span", t);
  //     },
  //   },
  {
    title: "推送到首页",
    key: "indexFlag",
    render: (h, params) => {
      // 1:推送首页 0：不推送首页
      let s = params.row.indexFlag;
      let t = s == "0" ? "不推送首页" : "推送首页";
      return h("span", t);
    },
  },
  {
    title: "发送时间",
    key: "effectTime",
    width: "150px",
  },
  {
    title: "消息内容",
    key: "content",
    render(h, params) {
      let text = params.row.content;
      if (text !== null) {
        if (text.length > 20) {
          text = params.row.content.slice(0, 20) + "...";
        }
      }
      return h("div", [
        h(
          "Tooltip",
          {
            props: {
              placement: "top",
              transfer: true,
            },
          },
          [
            text,
            h(
              "span",
              {
                slot: "content",
                style: {
                  whiteSpace: "normal",
                },
              },
              params.row.content
            ),
          ]
        ),
      ]);
    },
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
const options = {
  shortcuts: [
    {
      text: "1 week",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        return [start, end];
      },
    },
    {
      text: "1 month",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        return [start, end];
      },
    },
    {
      text: "3 months",
      value() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        return [start, end];
      },
    },
  ],
};
const statusList = [
  {
    label: "全部",
    value: "",
  },
  //已推送  待推送  已取消
  {
    label: "禁用",
    value: "1",
  },
  {
    label: "启用",
    value: "0",
  },
];
const targetList = [
  {
    label: "全部",
    value: "0",
  },
  {
    label: "门店",
    value: "1",
  },
  {
    label: "消费者",
    value: "2",
  },
];
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    return {
      editor: null,
      loading: false,
      options,
      columns,
      tbList: [],
      searchName: "",
      seTime: [],
      status: "",
      target: "",
      statusList,
      targetList,
      page: 1,
      pageSize: 10,
      total: 0,
      formModel: false,
      formModalLoading: true,
      formTitle: 0,
      updateId: "",
      formItem: {
        title: "",
        content: "",
        effectTime: "",
        indexFlag: "",
        remark: "",
        target: "",
        type: "",
      },
      ruleValidate: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            required: true,
            validator: (rule, value, callback) =>
              validateSelfHandler(
                "不为空且不能超过20个字符",
                /^.{1,20}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入消息内容", trigger: "blur" },
        ],
        effectTime: [
          { required: true, message: "请选择发送时间", trigger: "change" },
        ],
        indexFlag: [
          { required: true, message: "请选择是否推送首页", trigger: "change" },
        ],
        target: [
          { required: true, message: "请选择发送对象", trigger: "change" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.editorHandler();
  },
  methods: {
    toDetail(row) {
      this.$router.push({
        path: "/messageDetail",
        query: { id: row.id },
      });
    },
    typeChange(va) {
      if (va == 1) {
        if (this.editor) {
          this.editor.txt.html(this.formItem.content);
        }
      }
    },
    editorHandler() {
      const self = this;
      this.editor = new E(this.$refs.editor);
      this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        const fd = new FormData();
        fd.append("file", resultFiles[0]);
        self.$store
          .dispatch("uploadImage", fd)
          .then((res) => {
            if (res.code == 200) {
              insertImgFn(res.data.url);
            } else {
              self.$Message.error("图片上传失败");
            }
          })
          .catch((err) => {
            self.$Message.error("图片上传失败");
          });
      };
      // 配置 onchange 回调函数
      this.editor.config.onchange = function (newHtml) {
        self.formItem.content = newHtml;
      };
      // 配置触发 onchange 的时间频率，默认为 200ms
      this.editor.config.onchangeTimeout = 500;
      this.editor.create();
      this.editor.txt.html(this.formItem.content); // 重新设置编辑器内容
    },
    // 列表
    getList() {
      let data = {
        title: this.searchName,
        target: this.target,
        startDate: this.initTime(this.seTime, 0),
        endDate: this.initTime(this.seTime, 1),
        status: this.status,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.msgQueryList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          let list = res.data;
          if (!list || list.length == 0) {
            this.tbList = [];
            return;
          }
          this.tbList = list;
          this.total = res.total;
        }
      });
    },
    initTime(t, i) {
      if (!t[i]) {
        return "";
      }
      let d = t[i];
      let str = new Date(d);
      return this.tools.formatDate(str);
    },
    timeChange(v) {
      this.formItem.effectTime = v;
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.searchName = "";
      this.page = 1;
      this.pageSize = 10;
      this.target = "";
      this.seTime = [];
      this.status = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.formItem).forEach((key) => {
          this.formItem[key] = d[key];
        });
        this.updateId = d.id;
        if (this.editor && d.type == 1) {
          this.editor.txt.html(this.formItem.content);
        }
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 新增编辑确定
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = { ...this.formItem };
      data.target = 0;
      let http = "msgAdd";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.formTitle == 1) {
            data.id = this.updateId;
            http = "msgUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.resetList();
            }
          });
        }
      });
    },
    cancelAction() {
      Object.keys(this.formItem).forEach((key) => {
        this.formItem[key] = "";
      });
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 删除部门
    removeFn(i, d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.title}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.msgDelete({ id: d.id }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.resetList();
            }
          });
        },
      });
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "msgDisable" : "msgEnable";
      this.$api[http]({ id: d.id }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>
<style>
.ivu-date-picker .ivu-select-dropdown {
  z-index: 10002 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/message/messageList.vue